import { api } from './client'

/** R5-07 / Z-17: fatture passive lette da fatturazione.equalstudio.it (copia in sola lettura). */
export interface SupplierInvoiceRow {
  id: number
  externalId: number
  number: string
  issueDate: string
  supplierName: string
  supplierVat?: string | null
  supplierId?: number | null
  netAmount: number
  vatAmount: number
  totalAmount: number
  dueDate?: string | null
  status: string
  syncedAt: string
}

export interface SupplierInvoiceList {
  source: string
  total: number
  page: number
  pageSize: number
  lastSyncAt?: string | null
  sums: { net: number; vat: number; total: number }
  items: SupplierInvoiceRow[]
}

export interface SupplierInvoiceSyncResult {
  source: string
  available: boolean
  reason?: string | null
  message?: string | null
  created: number
  updated: number
  fetched: number
}

export const supplierInvoicesApi = {
  list: (p: { from?: string; to?: string; supplierId?: number; q?: string; page?: number } = {}) => {
    const qs = new URLSearchParams()
    if (p.from) qs.set('from', p.from)
    if (p.to) qs.set('to', p.to)
    if (p.supplierId) qs.set('supplierId', String(p.supplierId))
    if (p.q) qs.set('q', p.q)
    if (p.page) qs.set('page', String(p.page))
    const s = qs.toString()
    return api<SupplierInvoiceList>(`/api/finance/supplier-invoices${s ? `?${s}` : ''}`)
  },
  sync: (from?: string, to?: string) => {
    const qs = new URLSearchParams()
    if (from) qs.set('from', from)
    if (to) qs.set('to', to)
    const q = qs.toString()
    return api<SupplierInvoiceSyncResult>(`/api/finance/supplier-invoices/sync${q ? `?${q}` : ''}`, { method: 'POST' })
  },
}

/** R5-07 / Z-23: regole d'imposta modificabili dall'Admin, marcate «da confermare col commercialista». */
export interface TaxSettingsView {
  iresRate: number
  irapRate: number
  vatPeriodicity: string
  advancePercent: number
  firstAdvanceShare: number
  toConfirm: boolean
  note?: string | null
  confirmedAt?: string | null
  updatedAt?: string | null
}

export interface TaxDeadlineView {
  id: number
  code: string
  label: string
  kind: string
  month: number
  day: number
  isActive: boolean
}

export interface TaxSettingsBundle {
  settings: TaxSettingsView
  deadlines: TaxDeadlineView[]
}

export const taxApi = {
  get: () => api<TaxSettingsBundle>('/api/finance/tax/settings'),
  saveSettings: (b: { iresRate: number; irapRate: number; vatPeriodicity: string; advancePercent: number; firstAdvanceShare: number }) =>
    api<TaxSettingsView>('/api/finance/tax/settings', { method: 'PUT', body: JSON.stringify(b) }),
  saveDeadline: (id: number, b: { label?: string; month?: number; day?: number; isActive?: boolean }) =>
    api<TaxDeadlineView>(`/api/finance/tax/deadlines/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  confirm: () => api<TaxSettingsView>('/api/finance/tax/confirm', { method: 'POST' }),
}
